import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { ConferenceBannerRotatorComponent } from './conferences/page/elements/conference-banner-rotater/conference-banner-rotator.component';
import { ConferenceDateHeaderComponent } from './conferences/page/elements/conference-date-header/conference-date-header.component';
import { ConferenceEventListingComponent } from './conferences/page/elements/conference-event-listing/conference-event-listing.component';
import { ConferenceExhibitListingComponent } from './conferences/page/elements/conference-exhibits/conference-exhibit-listing.component';
import { ConferenceHtmlContentComponent } from './conferences/page/elements/conference-html-content/conference-html-content.component';
import { ConferenceListComponent } from './conferences/page/elements/conference-list/conference-list.component';
import { ConferenceOnDemandListingComponent } from './conferences/page/elements/conference-on-demand-listing/conference-on-demand-listing.component';
import { ConferenceOnDemandSearchComponent } from './conferences/page/elements/conference-on-demand-search/conference-on-demand-search.component';
import { ConferencePackageListingComponent } from './conferences/page/elements/conference-package-listing/conference-package-listing.component';
import { ConferencePdfViewerComponent } from './conferences/page/elements/conference-pdf-viewer/conference-pdf-viewer.component';
import { ConferencePosterListingComponent } from './conferences/page/elements/conference-poster-listing/conference-poster-listing.component';
import { ConferenceScheduleElementComponent } from './conferences/page/elements/conference-schedule/conference-schedule-element.component';
import { ConferenceSpeakerListingComponent } from './conferences/page/elements/conference-speaker-listing/conference-speaker-listing.component';
import { OrganizationBundlesComponent } from './conferences/page/elements/organization-bundles/organization-bundles.component';
import { OrganizationEventListingComponent } from './conferences/page/elements/organization-event-listing/organization-event-listing.component';
import { PageElementComponent } from './conferences/page/elements/page-element.component';
import { ConferenceProgramExportComponent } from './conferences/page/elements/program-export/conference-program-export.component';
import { SponsorProductListingComponent } from './conferences/page/elements/sponsor-product-listing/sponsor-product-listing.component';
import { AddEditExhibitComponent } from './superUser/conferences/exhibits/add-edit/add-edit-exhibit.component';
import { ExhibitInviteComponent } from './superUser/conferences/exhibits/exhibit-invite/exhibit-invite.component';
import { EmailRegistrantsModalComponent } from './superUser/events/email-registrants-modal.component';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';

@NgModule({
  declarations: [
    PageElementComponent,
    ConferenceHtmlContentComponent,
    ConferenceSpeakerListingComponent,
    ConferencePosterListingComponent,
    ConferenceBannerRotatorComponent,
    ConferenceListComponent,
    ConferencePackageListingComponent,
    ConferenceOnDemandListingComponent,
    ConferenceEventListingComponent,
    ConferenceDateHeaderComponent,
    ConferenceOnDemandSearchComponent,
    SponsorProductListingComponent,
    ConferenceExhibitListingComponent,
    ConferenceScheduleElementComponent,
    ConferenceProgramExportComponent,
    OrganizationEventListingComponent,
    ConferencePdfViewerComponent,
    OrganizationBundlesComponent,


  ],
  entryComponents: [],
  imports: [
    ApplicationPipesModule,
    DragDropModule,
    RouterModule,
    SkeletonModule,
    PaginatorModule,
    PdfViewerModule,
  ],
  exports: [
    PageElementComponent,ConferenceHtmlContentComponent,
    ConferenceSpeakerListingComponent,
    ConferencePosterListingComponent,
    ConferenceBannerRotatorComponent,
    ConferenceListComponent,
    ConferencePackageListingComponent,
    OrganizationBundlesComponent,
    ConferenceOnDemandListingComponent,
    ConferenceEventListingComponent,
    ConferenceDateHeaderComponent,
    ConferenceOnDemandSearchComponent,
    SponsorProductListingComponent,
    ConferenceExhibitListingComponent,
    ConferenceScheduleElementComponent,
    ConferenceProgramExportComponent,
    OrganizationEventListingComponent,
    ConferencePdfViewerComponent,


  ],
})
export class SharedCMSModule {}
